import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import * as _ from "lodash";
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from "src/app/app.main.component";
import { SalesOrderService } from "../sales-order.service";
import { CustomAttributeFieldType, SOObjectNames, TemplateType, RMA_Stage, SOChannel, RmaStages, ShipmentStatus, TabHeaderConst } from "../constants/constants";
import { ConfirmationService, MessageService } from "primeng/api";
import { Severity } from "../../constants/constants";
import { DatePipe, TitleCasePipe } from "@angular/common";
import { MyDocumentsService } from "src/app/profile/my-documents";
import { UtilityService } from "../utils/utility.service";
import { ImportserialService } from "src/app/modules/shared/services/importserial.service";
import { environment } from "src/environments/environment";
import { PermissionService } from "src/app/service/permission.service";
import { ObjectNames } from "src/app/shared/constants";
import { AccountsTransactionType } from "src/app/finance/constants/constants";

@Component({
    selector: "app-return-details",
    templateUrl: "./return-details.component.html",
    styleUrls: ["./return-details.component.scss"],
})
export class ReturnDetailsComponent implements OnInit , OnChanges {
    @Input() type: any;
    @Input() selectedReturn: any;
    @Input() selectedId: any;
    @Input() returnsData: any;
    @Input() customerReturnDetails: any;
    @Input() templates: any;
    @Input() allCustomAttributes: any;
    @Input() rmaSections = [];

    /** Shipment */
    @Input() vendorFedexInfo;
    @Input() fedexAccountInfo;
    @Input() allShippingMethods;
    @Input() vendorUpsInfo;
    @Input() allUpsAccounts;
    @Input() allFedexAccounts;

    @Output() onLabelCreate = new EventEmitter();
    @Output() onVoidShipment = new EventEmitter();
    @Output() onViewLabel = new EventEmitter();
    @Output() onFedexLabelCreate = new EventEmitter();
    @Output() onFedexVoidShipment = new EventEmitter();
    @Output() onFedexTrackShipment = new EventEmitter();
    @Output() onUpsShipment = new EventEmitter();
    @Output() onUpsVoidShipment = new EventEmitter();
    @Output() onUpsViewLabel = new EventEmitter();
    @Output() onUpsTrackShipment = new EventEmitter();

    @Output() updateContextMenu = new EventEmitter<any>();

    rmaStages: any[];
    approvalStage;
    fieldTypes = CustomAttributeFieldType;
    customFields = {
        billing_address_item: [],
        shipping_address_item: [],
        misc_item: [],
        section_item: [],
        footer_item: [],
        message_item: [],
        other1_item: [],
        other2_item: [],
        other3_item: [],
    };
    displayStageChange = false;
    allRMATypes = [];
    allReasons = [];
    showApproveOption = false;
    isAllowCreateCredit :boolean = false;
    selectedStage;
    selectedRMAType;
    selectedReason;
    // showShippingLabel: boolean = false;
    rmaProductList = [];
    isEdit = false;
    today = new Date();
    tempAttachment = [
        { id: 1, name: "panda.jpg", url: `${environment.assestsBasePath}images/panda.jpg`},
        { id: 1, name: "test.doc", url:   `${environment.assestsBasePath}images/panda.jpg`},
    ];
    approved = true;
    //tracking
    @Input() trackingOptions = [];
    utilityServiceObj: UtilityService;
    displayScanInfo = false;
    allChecked = false;
    nameLists = [];
    productSerialSettings:any;
    autoGenerateLists=[];
    totalTBRecord: number = 0;
    rowsPerPageTB = [100, 200, 300, 500];
    pageSize: number = 100;
    pageNumber: number = 1;
    first: number = 0;

    @ViewChild('stageAttachment')
    stageAttachment: any;
    customerInformation: any = {
        businessName: {
            value: "",
            show: true
        },
        customerAddress1: {
            value: "",
            show: false
        },
        customerAddress2: {
            value: "",
            show: false
        },
        customerName: {
            value: "",
            show: false
        },
        phoneNumber: {
            value: "",
            show: false
        },
        sequenceNumber: {
            value: "",
            show: false
        },
    };
    shippingLocation: any = {
        businessName: {
            value: "",
            show: true
        },
        address1: {
            value: "",
            show: false
        },
        address2: {
            value: "",
            show: false
        },
        accountName: {
            value: "",
            show: false
        },
        phoneNumber: {
            value: "",
            show: false
        },
        addressName: {
            value: "",
            show: true
        },
        sequenceNumber: {
            value: "",
            show: false
        },
    };
    rmaComments = [
        {
            userName: "User 1",
            date: new Date(),
            isApproved: true,
            stage: "Approved",
            comment: "This rma has been approved",
        },
        {
            userName: "User 2",
            date: new Date(),
            isApproved: false,
            stage: "Declined",
            comment: "This rma has been declined",
        },
    ];
    statementMessege : string = '';
    closingDate : any ;
    //tracking
    isPrefix: boolean = false;
    isAutoGenerated: boolean = false;
    displayImport = false;
    customerRmaObjectId;
    stageComment: string;
    rmaAttachments: any = [];
    MAX_SIZE: number = 5 * 1024 * 1024;
    totalFileSize: number = 0;
    attachmentList: any = [];
    attachmentId: any = 0;
    uploadedAttachments: any = [];
    rmaTemplate: any;
    customerRmaData: any = {
        rmaNumber: {
            value: "",
            show: true
        },
        invoiceNo: {
            value: "",
            show: true
        },
        status: {
            value: "",
            show: false
        },
        requestType: {
            value: "",
            show: false
        },
        createdDate: {
            value: "",
            show: false
        },
        location: {
            value: "",
            show: false
        },
        description: {
            value: "",
            show: false
        },
    };
    customerInformationLabel: string = 'Customer Information';
    shippingLocationLabel: string = 'Shipping Location';
    detailsLabel: string = 'Details';
    returnItemTable: any;
    requestTypeLabel: any;
    returnReasonLabel: any;
    footerColspan: any;
    subtotal: number = 0;
    totalRefund: number = 0;
    soChannel = SOChannel;

    /** Shipment */
    displayShipmentDialog = false;
    isVisibleCarrier = true;
    shippingCarriers = [];
    selectedCarrier;
    shipMessage = "";
    displayFedexShipment = false;
    shipmentOptionAvailableFor = [RmaStages.Authorized, RmaStages.Received];
    isVisibleGenerateLabelOption = true;
    // fedex
    selectedFedexAcc;

    // fraction digits
    fractionDigits: number = 0;
    qtyFractionDigits: number = 0;

    // currency
    baseCurrency: any;
    orgCurrency = [];
    savedCurrencyExchangeRate: any;
    savedCurrencyUnit: any;

    TabHeaderConst = TabHeaderConst;
    glTabPermission: boolean = false;
    glApiCall: boolean = false;
    transactionTypeIds = AccountsTransactionType;
    isAllowPostingPeriod: boolean = false;


    constructor(
        public app: AppMainComponent,
        private appMainService: AppMainService,
        private messageService: MessageService,
        private salesOrderService: SalesOrderService,
        private datePipe: DatePipe,
        private titleCasePipe: TitleCasePipe,
        private documentService: MyDocumentsService,
        private utilityService: UtilityService,
        private confirmationService: ConfirmationService,
        private importService: ImportserialService,
        private permissionService: PermissionService
    ) { }

    ngOnInit(): void {
        this.getIsettings();
        this.getBaseCurrency();
        this.getQtyDecimalDigits();
        this.utilityServiceObj = this.utilityService;
        this.customerRmaObjectId = this.app.preLoadedObjects.find(
            (obj) => obj.name == SOObjectNames.CustomerReturns
        )?.id;
        this.customerInformationLabel = 'Customer Information';
        this.shippingLocationLabel = 'Shipping Location';
        this.detailsLabel = 'Details';
        this.getFractionDigits();
        this.loadPermissionForGLTab();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.rmaTemplate = this.templates?.filter((t) => t.typeId == TemplateType.CustomerRMA)[0];
        this.returnItemTable = this.rmaTemplate?.labels_table;
        this.footerColspan = this.rmaTemplate?.labels_table?.filter(x => x.isChecked)!.length + 1;
        if (this.rmaTemplate) {
            this.customFields = this.utilityService.getCustomerRMACustomAttributes(this.rmaTemplate, this.allCustomAttributes);
            this.prepareCustomerInformation();
            this.prepareShippingLocation();
            this.prepareRmaProductList();
            this.prepareRmaAttachments();
            this.prepareRmaData();
        }
        this.requestTypeLabel = this.rmaTemplate?.labels_section[0].labelname;
        this.returnReasonLabel = this.rmaTemplate?.labels_section[4].labelname;
        this.rmaStages = this.selectedReturn?.stages;
        this.prepareApprovalStage();
        if (this.customerReturnDetails) {
            this.checkIsVisibleGenerateLabelOption();
            this.closingDate = this.app._showDateTimeWithZone(this.customerReturnDetails?.createdDate)
        }
        if(this.allFedexAccounts && this.allFedexAccounts?.length > 0){
            this.selectedFedexAcc = this.allFedexAccounts?.find((a) => a.isDefault == true);
        }
    }
    getQtyDecimalDigits() {
        this.importService.getQtyDecimalValue().subscribe((value) => {
            if (value) {
                this.qtyFractionDigits = value;
                
            }
        });
    }
    getBaseCurrency() {
        this.importService
            .getOrgCurrency()
            .subscribe((value) => {
                if (value) {
                    this.baseCurrency = value.find((cr) => cr.isBaseCurrency);
                    this.orgCurrency = value;
                }
            });
    }

    getSectionName(sectionCode) {
        const sectionName = this.rmaSections?.find(section => section.code == sectionCode)?.name;
        return sectionName;
    }

    prepareRmaData(): any {
        if (this.selectedReturn) {
            //rma and invoice number is shown by default
            this.customerRmaData.rmaNumber.value = this.selectedReturn?.rmaNumber;
            this.customerRmaData.invoiceNo.value = this.selectedReturn?.invoiceNo;

            this.customerRmaData.createdDate.value = this.selectedReturn?.createdDate;
            this.customerRmaData.createdDate.show = this.rmaTemplate?.labels_misc[0].isChecked;
            this.customerRmaData.status.value = this.selectedReturn?.stage;
            this.customerRmaData.status.show = this.rmaTemplate?.labels_misc[1].isChecked;
            this.customerRmaData.requestType.value = this.selectedReturn?.requestType;
            this.customerRmaData.requestType.show = this.rmaTemplate?.labels_misc[2].isChecked;
            this.customerRmaData.description.value = this.selectedReturn?.description;
            this.customerRmaData.description.show = this.rmaTemplate?.labels_misc[4].isChecked;
            this.customerRmaData.location.value = this.selectedReturn?.location;
            this.customerRmaData.location.show = this.rmaTemplate?.labels_misc[5].isChecked;
        }

        if (this.customerReturnDetails) {
            const controlTypeMappings = {
                "InputBox": (element, fc) => element.value = fc.value,
                "DatePicker": (element, fc) => element.value = this.datePipe.transform(fc.value, "MM/dd/yyyy"),
                "FileUpload": (element, fc) => element.customUploadedFiles = [...fc.customeAttachement],
                "Picture": (element, fc) => element.customUploadedFiles = [...fc.customeAttachement],
                "Rating": (element, fc) => element.value = fc.ratingId,
                "ToggleButton": (element, fc) => element.value = fc.toggle,
                "DropDownList": (element, fc) => element.value = fc.values,
                "RadioButton": (element, fc) => element.value = fc.values?.name,
                "CheckBox": (element, fc) => element.value = fc.multipleValues.map(el => el.name),
                "MultipleDropDownList": (element, fc) => element.value = [...fc.multipleValues],
            };

            // populate saved custom field data
            Object.keys(this.customFields).forEach((key) => {
                const dataArr = this.customFields[key];
                if (dataArr && dataArr.length > 0) {
                    dataArr.forEach((element) => {
                        const filteredCustom = this.customerReturnDetails?.customAttributeValues.find(c =>
                            c.customAttributeId === element.id);
                        if (filteredCustom && element?.formControl?.name in controlTypeMappings) {
                            controlTypeMappings[element.formControl.name](element, filteredCustom);
                        }
                    });
                }
            });
        }
    }

    checkIsVisibleGenerateLabelOption(){
        this.isVisibleGenerateLabelOption = true;
        let isShipmentLabelCreated = false;
        if (this.customerReturnDetails?.rmaReturnShipment && this.customerReturnDetails?.rmaReturnShipment.length) {
            const shipments = this.customerReturnDetails?.rmaReturnShipment.filter((s) => s.statusId == ShipmentStatus.Active || s.statusId == ShipmentStatus.InActive);
            isShipmentLabelCreated = shipments && shipments.length > 0;
        }
        this.isVisibleGenerateLabelOption = !isShipmentLabelCreated && this.shipmentOptionAvailableFor.includes(this.selectedReturn?.selectedStageId);
    }

    prepareRmaAttachments() {
        if (this.customerReturnDetails
            && this.customerReturnDetails?.rmaAttachments) {
            this.rmaAttachments = this.customerReturnDetails?.rmaAttachments;
        }
    }

    prepareApprovalStage() {
        if (
            this.selectedReturn?.selectedStageId == 4 ||
            this.selectedReturn?.selectedStageId == 5
        ) {
            this.rmaStages.forEach((x) => {
                if (x.id == this.selectedReturn?.selectedStageId) {
                    x.isActive = true;
                }
            });
        } else {
            this.rmaStages.forEach((x) => {
                if (x.id == 6) {
                    x.isActive = true;
                }
            });
        }
    }

    prepareCustomerInformation() {
        if (this.customerReturnDetails) {
            let customerInfo = this.customerReturnDetails?.customerInfo;
            this.savedCurrencyUnit = this.customerReturnDetails?.account?.currencyUnit;
            this.customerReturnDetails.postingDate = this.app._showDateTimeWithZone(this.customerReturnDetails?.postingDate);
            if (customerInfo) {
                //business name shown by default
                this.customerInformation.businessName.value = customerInfo?.businessName;

                this.customerInformation.customerName.value = customerInfo?.accountName;
                this.customerInformation.customerName.show = this.rmaTemplate?.labels_billaddress[0].isChecked;
                this.customerInformation.customerAddress1.value = customerInfo?.address1;
                this.customerInformation.customerAddress1.show = this.rmaTemplate?.labels_billaddress[1].isChecked;
                this.customerInformation.customerAddress2.value = customerInfo?.address2;
                this.customerInformation.customerAddress2.show = this.rmaTemplate?.labels_billaddress[2].isChecked;
                this.customerInformation.phoneNumber.value = customerInfo?.phoneNumber;
                this.customerInformation.phoneNumber.show = this.rmaTemplate?.labels_billaddress[4].isChecked;
                
                this.customerInformation.sequenceNumber.value = this.customerReturnDetails?.account?.sequenceNumber ?? "";
                this.customerInformation.sequenceNumber.show = this.rmaTemplate?.labels_billaddress[5].isChecked;
            }
        }
    }

    prepareShippingLocation() {
        if (this.customerReturnDetails) {
            let address = this.customerReturnDetails?.address;

            if (address) {
                //business name shown by default
                this.shippingLocation.businessName.value = address?.businessName;
                this.shippingLocation.businessName.show = address?.businessName;

                this.shippingLocation.accountName.value = address?.accountName;
                this.shippingLocation.accountName.show = this.rmaTemplate?.labels_shipaddress[0].isChecked;
                this.shippingLocation.address1.value = address?.address1;
                this.shippingLocation.address1.show = this.rmaTemplate?.labels_shipaddress[1].isChecked;
                this.shippingLocation.address2.value = address?.address2;
                this.shippingLocation.address2.show = this.rmaTemplate?.labels_shipaddress[2].isChecked;
                this.shippingLocation.phoneNumber.value = address?.phoneNumber;
                this.shippingLocation.phoneNumber.show = this.rmaTemplate?.labels_shipaddress[4].isChecked;
                this.shippingLocation.addressName.value = address?.addressName;

                this.shippingLocation.sequenceNumber.value = this.customerReturnDetails?.account?.sequenceNumber ?? "";
                this.shippingLocation.sequenceNumber.show = this.rmaTemplate?.labels_shipaddress[5].isChecked;
            }
        }
    }

    convertProductPriceByExchangeRate(products: any[], exchangeRate: number = 1) {
        const updatePrices = (item: any) => {
            const updatedItem = {
                ...item,
                amount: item.amount * (exchangeRate ?? this.baseCurrency?.exchangeRate),
                rate: item.rate * (exchangeRate ?? this.baseCurrency?.exchangeRate),
                shippingPerPrice: item.shippingPerPrice * (exchangeRate ?? this.baseCurrency?.exchangeRate),
                originalPrice: item.originalPrice * (exchangeRate ?? this.baseCurrency?.exchangeRate),
                returnAmount: item.returnAmount * (exchangeRate ?? this.baseCurrency?.exchangeRate),
                taxPerPrice: item.taxPerPrice * (exchangeRate ?? this.baseCurrency?.exchangeRate),
                discountPerPrice: item.discountPerPrice * (exchangeRate ?? this.baseCurrency?.exchangeRate),
            };

            if (updatedItem?.invoiceBundleDto && updatedItem?.invoiceBundleDto?.length > 0) {
                updatedItem.invoiceBundleDto = updatedItem.invoiceBundleDto.map((bundleItem) => updatePrices(bundleItem));
            }
            return updatedItem;
        };
        return products.map((item) => updatePrices(item));
    }

    prepareRmaProductList() {
        if (this.customerReturnDetails) {
            //this.rmaProductList = this.customerReturnDetails?.customerRMAProducts;
            this.rmaProductList = this.convertProductPriceByExchangeRate(this.customerReturnDetails?.customerRMAProducts, this.customerReturnDetails?.exchangeRate);
            for (let prd of this.rmaProductList) {
                prd.returnamt = prd.returnAmount;
                prd.returnqty = prd.returnQty;
                prd.bin = prd.bins?.filter(bin => bin.id == prd.binId).map(binData => binData.name)[0];
                for (let bItems of prd.rmaBundleDetails) {
                    bItems.returnamt = bItems.returnAmount;
                    bItems.returnqty = bItems.returnQty;
                    bItems.bin = bItems.bins?.filter(bin => bin.id == bItems.binId).map(binData => binData.name)[0];
                }
            }
            this.calculateSubTotalAmount();
            this.calculateTotalRefundAmount();
        }
    }

    calculateSubTotalAmount() {
        this.subtotal = 0;
        for (let prd of this.rmaProductList) {
            this.subtotal += this.roundToTwoDecimal(Number(prd.returnAmount))
        }
        this.subtotal = this.roundToTwoDecimal(this.subtotal);
    }

    roundToTwoDecimal(data: number) {
        return Math.round((data + Number.EPSILON) * 100) / 100;
    }

    calculateTotalRefundAmount() {
        this.totalRefund = 0;
        this.rmaProductList.forEach(
            (e) => (this.totalRefund += this.roundToTwoDecimal(Number(e.returnAmount)))
        );
        this.totalRefund = this.roundToTwoDecimal(this.totalRefund);
    }


    editRMA() {
        this.isEdit = true;
        this.salesOrderService.getAllReturnReasons().subscribe((res) => {
            if (res) {
                this.allReasons = res;
                this.selectedReason = this.allReasons?.find(reason => reason.id == this.customerReturnDetails?.rmaReasonId);
            }
        });
        this.salesOrderService.getAllReturnTypes().subscribe((res) => {
            if (res) {
                this.allRMATypes = res;
                this.selectedRMAType = this.allRMATypes?.find(type => type.id == this.customerReturnDetails?.rmaTypeId);
            }
        });
    }

    changeStage(stage) {
        if (stage.id <= this.selectedReturn?.selectedStageId) {
            return;
        }
        this.selectedStage = JSON.parse(JSON.stringify(stage));
        if (stage.id == RMA_Stage.Approved || stage.id == RMA_Stage.Declined || stage.id == RMA_Stage.Approve_Decline) {
            this.showApproveOption = true;
        } else {
            this.showApproveOption = false;
        }
        this.stageAttachment.clear();
        this.getRmaComments();
        this.selectedReason = null;
        this.selectedRMAType = null;
        this.displayStageChange = true;
        
    }

    isClosingStatementDate(event : string) {
        this.statementMessege = event ;
    }

    saveStage(authorize?) {
        if (this.selectedStage?.id == RMA_Stage.Approved || this.selectedStage?.id == RMA_Stage.Declined ||
            this.selectedStage?.id == RMA_Stage.Approve_Decline) {
            if (authorize == "approve") {
                this.selectedReturn.selectedStageId = RMA_Stage.Approved;
                this.selectedReturn.stage = "Approved";
                for (let s of this.selectedReturn?.stages) {
                    if (s.id == RMA_Stage.Declined || s.id == RMA_Stage.Approve_Decline) {
                        s.isActive = false;
                    } else if (s.id == RMA_Stage.Approved) {
                        s.isActive = true;
                    }
                }
                const iSettings = this.utilityService.getISettings();
                this.isAllowCreateCredit = iSettings?.find(obj=>obj.code == 'rmaautocredit')?.enabled;
            } else if (authorize == "decline") {
                this.selectedReturn.selectedStageId = RMA_Stage.Declined;
                this.selectedReturn.stage = "Declined";
                for (let s of this.selectedReturn?.stages) {
                    if (s.id == RMA_Stage.Approved || s.id == RMA_Stage.Approve_Decline) {
                        s.isActive = false;
                    }
                    if (s.id == RMA_Stage.Declined) {
                        s.isActive = true;
                    }
                }
            }
        } else {
            this.selectedReturn.selectedStageId = this.selectedStage?.id || this.selectedReturn.statusId;
            this.selectedReturn.stage = this.selectedStage?.name;
        }
        this.updateStage(this.isAllowCreateCredit && this.customerRmaData.requestType.value == 'Credit');
        this.isEdit = false;
        this.displayStageChange = false;
    }
    createCredit(){
        this.selectedReturn.selectedStageId = this.customerReturnDetails.rmaStageId;
        this.updateStage(true);
    }
    updateStage(isCreateCredit) {
        const objectStageAudit = {
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            organizationId: this.app.companyId,
            objectRecordId: this.selectedReturn?.id,
            objectId: this.customerRmaObjectId,
            comment: this.stageComment,
            stageId: this.selectedReturn?.selectedStageId,
            isPublic: false,
            statusId: 1,
            isPublicOption: {
                label: "Private",
                value: true,
            },
        };
        this.appMainService.isShowSpinner("loadCustomerReturn");
        if (this.attachmentList && this.attachmentList.length > 0) {
            this.attachmentId = this.attachmentList[this.attachmentList.length - 1].attachmentId;
        }
        const returnTypeId = (this.selectedRMAType ? this.selectedRMAType?.id : this.customerReturnDetails?.rmaTypeId);
        const returnReasonId = (this.selectedReason ? this.selectedReason?.id : this.customerReturnDetails?.rmaReasonId);
        this.salesOrderService.updateRmaStage(this.selectedReturn?.id, this.selectedReturn?.selectedStageId, returnTypeId, returnReasonId, this.attachmentId, objectStageAudit,isCreateCredit)
            .then(() => {
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Stage updated successfully...",
                });
                this.appMainService.isHideSpinner("loadCustomerReturn");
                this.displayStageChange = false;
                this.selectedId = this.selectedReturn?.id;
                this.stageComment = "";
                this.updateContextMenu.emit({ id: this.selectedId });
                this.app.getAllActivityLog("lastfiveactivity", "allactivity", 1, 5, "", true, true, true);
            })
            .catch(() => {
                this.appMainService.isHideSpinner("loadCustomerReturn");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while updating data...",
                });
            });

        for (let s of this.returnsData) {
            if (s.id == this.selectedReturn?.id) {
                s = JSON.parse(JSON.stringify(this.selectedReturn));
            }
        }
    }

    cancleStage() {
        this.isEdit = false;
        this.displayStageChange = false;
    }


    //tracking
    openScanInfo(product,type) {
        this.nameLists = [];
        this.autoGenerateLists = [];
        this.productSerialSettings = product.trackingSetting ? JSON.parse(product.trackingSetting) : null;
        this.displayScanInfo = true;
        const arr = [];
        if(type=='product'){
            if (product.rmaProductSerialDetails?.length > 0) {
                product.rmaProductSerialDetails.forEach((element) => {
                    const obj = {
                        id: element.id,
                        serialNo: element.barcode,
                        serialNo2: element.serialNumber2,
                        serialNo3: element.serialNumber3,
                        serialNo4: element.serialNumber4,
                        serialNo5: element.serialNumber5,
                        serialNo6: element.serialNumber6,
                        serialNo7: element.serialNumber7,
                        serialNo8: element.serialNumber8,
                        serialNo9: element.serialNumber9,
                        serialNo10: element.serialNumber10,
                        serialNo11: element.serialNumber11,
                        serialNo12: element.serialNumber12,
                        serialNo13: element.serialNumber13,
                        serialNo14: element.serialNumber14,
                        serialNo15: element.serialNumber15,
                        serialNo16: element.serialNumber16,
                        serialNo17: element.serialNumber17,
                        lotNo: element.lotNumber,
                        revisionNo: element.revisionNumber,
                        expiration: element.expirationDate,
                        systemPresent: true,
                    };
                    arr.push(obj);
                });
            }
        }else{
            if (product.rmaBundleProductSerialDetail?.length > 0) {
                product.rmaBundleProductSerialDetail.forEach((element) => {
                    const obj = {
                        id: element.id,
                        serialNo: element.barcode,
                        serialNo2: element.serialNumber2,
                        serialNo3: element.serialNumber3,
                        serialNo4: element.serialNumber4,
                        serialNo5: element.serialNumber5,
                        serialNo6: element.serialNumber6,
                        serialNo7: element.serialNumber7,
                        serialNo8: element.serialNumber8,
                        serialNo9: element.serialNumber9,
                        serialNo10: element.serialNumber10,
                        serialNo11: element.serialNumber11,
                        serialNo12: element.serialNumber12,
                        serialNo13: element.serialNumber13,
                        serialNo14: element.serialNumber14,
                        serialNo15: element.serialNumber15,
                        serialNo16: element.serialNumber16,
                        serialNo17: element.serialNumber17,
                        lotNo: element.lotNumber,
                        revisionNo: element.revisionNumber,
                        expiration: element.expirationDate,
                        systemPresent: true,
                    };
                    arr.push(obj);
                });
            }
        }
        this.autoGenerateLists = arr;
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.totalTBRecord = this.autoGenerateLists.length;;
    }

    loadSerialsLazy(event) {
        if (this.autoGenerateLists) {
            this.nameLists = this.autoGenerateLists.slice(
                event.first,
                event.first + event.rows
            );
        }
    }

    getRmaComments() {
        this.salesOrderService.getRmaStageChangeHistory(this.selectedReturn?.id,this.customerRmaObjectId).subscribe((res) => {
                this.rmaComments = res;
            });
    }

    saveSelectedAttachments(event) {
        for (let file of event.files) {
            this.totalFileSize += file.size;
            this.uploadedAttachments.push(file);
        }
        this.createUpdateFolderFiles();
    }

    createUpdateFolderFiles() {
        if (this.totalFileSize > this.MAX_SIZE) {
            this.messageService.add({
                severity: Severity.Warn,
                summary: "Maximum Upload Size Limit Exceeded",
                detail: "Maximum upload size is 5MB!",
            });
            return;
        }

        const formData = this.setFormData(this.uploadedAttachments);
        formData.append("ModuleNameWithDisplayOrder", "CustomerRMA-1");

        this.appMainService.isShowSpinner("uplaodFile");
        this.documentService.uploadFilesByOrganization(formData).subscribe({
            next: (data) => {
                this.attachmentList.push(...data);

                this.appMainService.isHideSpinner("uplaodFile");
                this.messageService.add({
                    severity: Severity.Success,
                    summary: this.titleCasePipe.transform(Severity.Success),
                    detail: "Saved Successfully ...",
                });
            },
            error: (error) => {
                this.appMainService.isHideSpinner("uplaodFile");
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titleCasePipe.transform(Severity.Error),
                    detail: "Error occurred ...",
                });
            },
        });
    }

    setFormData(files): any {
        const formData = new FormData();
        for (let file of files) {
            formData.append("Files", file);
        }
        return formData;
    }


    /** Shipment */

    showShipmentDialog() {
        if (this.allShippingMethods && this.allShippingMethods.length) {
            this.shippingCarriers = this.allShippingMethods.filter((s) => s.isAPIConfigured == true);
            this.selectedCarrier = this.allShippingMethods.filter((s) => s.isDefault == true)[0];
        }
        this.displayShipmentDialog = true;
        this.isVisibleCarrier = true;
    }
    onShipmentDialogClose() {
        this.selectedCarrier = null;
        this.displayShipmentDialog = false;
        this.isVisibleCarrier = false;
    }
    createLabel(e) {
        this.displayShipmentDialog = false;
        this.onLabelCreate.emit(e);
    }
    createFedexLabel(e) {
        this.displayShipmentDialog = false;
        this.onFedexLabelCreate.emit(e);
    }
    onSuccessfullUpsShipment(e) {
        this.displayShipmentDialog = false;
        this.onUpsShipment.emit(e);
    }
    voidShipment(e) {
        this.confirmationService.confirm({
            message: "Do you want to void this Shipment?",
            header: "Void Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                if (e.trackingLink == "FEDEX") {
                    this.onFedexVoidShipment.emit(e);
                } else if (e.trackingLink == "UPS") {
                    this.onUpsVoidShipment.emit(e);
                } else {
                    this.onVoidShipment.emit(e);
                }
            },
            reject: () => {},
        });
    }
    viewLabelPdf(e) {
        if (e.trackingLink == "UPS") {
            this.onUpsViewLabel.emit(e);
        } else {
            this.onViewLabel.emit(e?.labelLink);
        }
    }
    showFedexShipment() {
        this.displayFedexShipment = true;
    }
    onFedexShipmentDialogClose() {
        this.displayFedexShipment = false;
    }
    trackUpsShipment(trackingNo) {
        this.salesOrderService.trackUpsShipment(trackingNo, this.vendorUpsInfo?.id).subscribe((res) => {
            this.shipMessage = res.trackResponse?.shipment[0]?.package[0]?.activity[0]?.status?.description || "";
        });
    }
    trackFedexShipment(trackingNo) {
        this.onFedexTrackShipment.emit(trackingNo);
    }

    onStepChange(e) {
        this.isVisibleCarrier = e;
    }

    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .subscribe({
                next: (value) => {
                    if(value){
                        this.fractionDigits = value;
                    }
                },
                error: (error) => {},
            });
    }

    loadPermissionForGLTab(){
        const userPermissions = this.permissionService.getPermissionData();
        const financeUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.FINANCE);
        this.glTabPermission = financeUserPermission ? (financeUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;
    }

    handleTabChange(event){
        if(event.index == 1){
            this.glApiCall = true;
        }else{
            this.glApiCall = false;
        }
    }

    getIsettings(){
        const iSettings = this.utilityService.getISettings();
        this.isAllowPostingPeriod = iSettings?.find((obj) => obj.code === "posting")?.enabled ?? false;
        console.log("this.isAllowPostingPeriod", this.isAllowPostingPeriod);
    }
}
